import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-therapy-crohn',
    templateUrl: './bar-chart-stable-unstable-therapy-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-therapy-crohn.component.css']
})

export class BarChartStableUnstableTherapyCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  // 5ASAOS, TOPICA, GSCOS, IMM, BIO
  remissione =[];
  attivitaLieve =[];
  attivitaModerata =[];
  attivitaGrave = [];
  // other arrays
  stabiliLieve5ASAOS = 0;
  stabiliModerata5ASAOS = 0;
  stabiliGrave5ASAOS = 0;
  stabiliRemissione5ASAOS = 0;
  instabiliMiglLieve5ASAOS = 0;
  instabiliMiglModerata5ASAOS = 0;
  instabiliMiglGrave5ASAOS = 0;
  instabiliPegLieve5ASAOS = 0;
  instabiliPegModerata5ASAOS = 0;
  instabiliPegGrave5ASAOS = 0;
  instabiliMiglRemissione5ASAOS = 0;
  instabiliPegRemissione5ASAOS = 0;
  
  stabiliLieveTOPICA = 0;
  stabiliModerataTOPICA = 0;
  stabiliGraveTOPICA = 0;
  stabiliRemissioneTOPICA = 0;
  instabiliMiglLieveTOPICA = 0;
  instabiliMiglModerataTOPICA = 0;
  instabiliMiglGraveTOPICA = 0;
  instabiliPegLieveTOPICA = 0;
  instabiliPegModerataTOPICA = 0;
  instabiliPegGraveTOPICA = 0;
  instabiliMiglRemissioneTOPICA = 0;
  instabiliPegRemissioneTOPICA = 0;
  
  stabiliLieveGCSOS = 0;
  stabiliModerataGCSOS = 0;
  stabiliGraveGCSOS = 0;
  stabiliRemissioneGCSOS = 0;
  instabiliMiglLieveGCSOS = 0;
  instabiliMiglModerataGCSOS = 0;
  instabiliMiglGraveGCSOS = 0;
  instabiliPegLieveGCSOS = 0;
  instabiliPegModerataGCSOS = 0;
  instabiliPegGraveGCSOS = 0;
  instabiliMiglRemissioneGCSOS = 0;
  instabiliPegRemissioneGCSOS = 0;
  
  stabiliLieveBIO = 0;
  stabiliModerataBIO = 0;
  stabiliGraveBIO = 0;
  stabiliRemissioneBIO = 0;
  instabiliMiglLieveBIO = 0;
  instabiliMiglModerataBIO = 0;
  instabiliMiglGraveBIO = 0;
  instabiliPegLieveBIO = 0;
  instabiliPegModerataBIO = 0;
  instabiliPegGraveBIO = 0;
  instabiliMiglRemissioneBIO = 0;
  instabiliPegRemissioneBIO = 0;

  stabiliLieveIMM = 0;
  stabiliModerataIMM = 0;
  stabiliGraveIMM = 0;
  stabiliRemissioneIMM = 0;
  instabiliMiglLieveIMM = 0;
  instabiliMiglModerataIMM = 0;
  instabiliMiglGraveIMM = 0;
  instabiliPegLieveIMM = 0;
  instabiliPegModerataIMM = 0;
  instabiliPegGraveIMM = 0;
  instabiliMiglRemissioneIMM = 0;
  instabiliPegRemissioneIMM = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableCrohnTherapy: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['5-ASA-OS-STABILI','5-ASA-OS-IN MIGLIORAMENTO','5-ASA-OS-IN PEGGIORAMENTO',
  'TOPICA-STABILI','TOPICA-IN MIGLIORAMENTO','TOPICA-IN PEGGIORAMENTO',
  'GCS-OS-STABILI','GCS-OS-IN MIGLIORAMENTO','GCS-OS-IN PEGGIORAMENTO',
  'BIO.-STABILI','BIO.-IN MIGLIORAMENTO','BIO.-IN PEGGIORAMENTO',
  'IMM.-STABILI','IMM.-IN MIGLIORAMENTO','IMM.-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 10,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491',
       '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800',
       '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 10,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', 
        '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', 
        '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 10,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
        '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', 
        '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', 
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', 
      '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveTherapyStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveTherapyStableAndUnstable(){
    this.subscription = this.doctorService.getCrohnStableAndUnstableTherapy().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissioneTherapy5ASAOS'){
            this.stabiliRemissione5ASAOS = values[i];
          }
          else if (key === 'StabiliLieveTherapy5ASAOS'){
            this.stabiliLieve5ASAOS = values[i];
          }
          else if (key === 'StabiliModerataTherapy5ASAOS'){
            this.stabiliModerata5ASAOS = values[i];
          }
          else if (key === 'StabiliGraveTherapy5ASAOS'){
            this.stabiliGrave5ASAOS = values[i];
          }
          else if (key === 'InstabiliMiglLieveTherapy5ASAOS'){
            this.instabiliMiglLieve5ASAOS = values[i];
          }
          else if (key === 'InstabiliMiglModerataTherapy5ASAOS'){
            this.instabiliMiglModerata5ASAOS = values[i];
          }
          else if (key === 'InstabiliMiglGraveTherapy5ASAOS'){
            this.instabiliMiglGrave5ASAOS = values[i];
          }
          else if (key === 'InstabiliLieveTherapy5ASAOS'){
            this.instabiliPegLieve5ASAOS = values[i];
          }
          else if (key === 'InstabiliPegModerataTherapy5ASAOS'){
            this.instabiliPegModerata5ASAOS = values[i];
          }
          else if (key === 'InstabiliPegGraveTherapy5ASAOS'){
            this.instabiliPegGrave5ASAOS = values[i];
          }
          else if (key === 'InstabiliMiglRemissioneTherapy5ASAOS'){
            this.instabiliMiglRemissione5ASAOS = values[i];
          }
          else if (key === 'InstabiliPegRemissioneTherapy5ASAOS'){
            this.instabiliPegRemissione5ASAOS = values[i];
          }
          else if (key === 'StabiliRemissioneTherapyTOPICA'){
            this.stabiliRemissioneTOPICA = values[i];
          }
          else if (key === 'StabiliLieveTherapyTOPICA'){
            this.stabiliLieveTOPICA = values[i];
          }
          else if (key === 'StabiliModerataTherapyTOPICA'){
            this.stabiliModerataTOPICA = values[i];
          }
          else if (key === 'StabiliGraveTherapyTOPICA'){
            this.stabiliGraveTOPICA = values[i];
          }
          else if (key === 'InstabiliMiglLieveTherapyTOPICA'){
            this.instabiliMiglLieveTOPICA = values[i];
          }
          else if (key === 'InstabiliMiglModerataTherapyTOPICA'){
            this.instabiliMiglModerataTOPICA = values[i];
          }
          else if (key === 'InstabiliMiglGraveTherapyTOPICA'){
            this.instabiliMiglGraveTOPICA = values[i];
          }
          else if (key === 'InstabiliPegLieveTherapyTOPICA'){
            this.instabiliPegLieveTOPICA = values[i];
          }
          else if (key === 'InstabiliPegModerataTherapyTOPICA'){
            this.instabiliPegModerataTOPICA = values[i];
          }
          else if (key === 'InstabiliPegGraveTherapyTOPICA'){
            this.instabiliPegGraveTOPICA = values[i];
          }
          else if (key === 'InstabiliMiglRemissioneTherapyTOPICA'){
            this.instabiliMiglRemissioneTOPICA = values[i];
          }
          else if (key === 'InstabiliPegRemissioneTherapyTOPICA'){
            this.instabiliPegRemissioneTOPICA = values[i];
          }
          else if (key === 'StabiliRemissioneTherapyGCSOS'){
            this.stabiliRemissioneGCSOS = values[i];
          }
          else if (key === 'StabiliLieveTherapyGCSOS'){
            this.stabiliLieveGCSOS = values[i];
          }
          else if (key === 'StabiliModerataTherapyGCSOS'){
            this.stabiliModerataGCSOS = values[i];
          }
          else if (key === 'StabiliGraveTherapyGCSOS'){
            this.stabiliGraveGCSOS = values[i];
          }
          else if (key === 'InstabiliMiglLieveTherapyGCSOS'){
            this.instabiliMiglLieveGCSOS = values[i];
          }
          else if (key === 'InstabiliMiglModerataTherapyGCSOS'){
            this.instabiliMiglModerataGCSOS = values[i];
          }
          else if (key === 'InstabiliMiglGraveTherapyGCSOS'){
            this.instabiliMiglGraveGCSOS = values[i];
          }
          else if (key === 'InstabiliPegLieveTherapyGCSOS'){
            this.instabiliPegLieveGCSOS = values[i];
          }
          else if (key === 'InstabiliPegModerataTherapyGCSOS'){
            this.instabiliPegModerataGCSOS = values[i];
          }
          else if (key === 'InstabiliPegGraveTherapyGCSOS'){
            this.instabiliPegGraveGCSOS = values[i];
          }
          else if (key === 'InstabiliMiglRemissioneTherapyGCSOS'){
            this.instabiliMiglRemissioneGCSOS = values[i];
          }
          else if (key === 'InstabiliPegRemissioneTherapyGCSOS'){
            this.instabiliPegRemissioneGCSOS = values[i];
          }
          else if (key === 'StabiliRemissioneTherapyBIO'){
            this.stabiliRemissioneBIO = values[i];
          }
          else if (key === 'StabiliLieveTherapyBIO'){
            this.stabiliLieveBIO = values[i];
          }
          else if (key === 'StabiliModerataTherapyBIO'){
            this.stabiliModerataBIO = values[i];
          }
          else if (key === 'StabiliGraveTherapyBIO'){
            this.stabiliGraveBIO = values[i];
          }
          else if (key === 'InstabiliMiglLieveTherapyBIO'){
            this.instabiliMiglLieveBIO = values[i];
          }
          else if (key === 'InstabiliMiglModerataTherapyBIO'){
            this.instabiliMiglModerataBIO = values[i];
          }
          else if (key === 'InstabiliMiglGraveTherapyBIO'){
            this.instabiliMiglGraveBIO = values[i];
          }
          else if (key === 'InstabiliPegLieveTherapyBIO'){
            this.instabiliPegLieveBIO = values[i];
          }
          else if (key === 'InstabiliPegModerataTherapyBIO'){
            this.instabiliPegModerataBIO = values[i];
          }
          else if (key === 'InstabiliPegGraveTherapyBIO'){
            this.instabiliPegGraveBIO = values[i];
          }
          else if (key === 'InstabiliMiglRemissioneTherapyBIO'){
            this.instabiliMiglRemissioneBIO = values[i];
          }
          else if (key === 'InstabiliPegRemissioneTherapyBIO'){
            this.instabiliPegRemissioneBIO = values[i];
          }
          if (key === 'StabiliRemissioneTherapyIMM'){
            this.stabiliRemissioneIMM = values[i];
          }
          else if (key === 'StabiliLieveTherapyIMM'){
            this.stabiliLieveIMM = values[i];
          }
          else if (key === 'StabiliModerataTherapyIMM'){
            this.stabiliModerataIMM = values[i];
          }
          else if (key === 'StabiliGraveTherapyIMM'){
            this.stabiliGraveIMM = values[i];
          }
          else if (key === 'InstabiliMiglLieveTherapyIMM'){
            this.instabiliMiglLieveIMM = values[i];
          }
          else if (key === 'InstabiliMiglModerataTherapyIMM'){
            this.instabiliMiglModerataIMM = values[i];
          }
          else if (key === 'InstabiliMiglGraveTherapyIMM'){
            this.instabiliMiglGraveIMM = values[i];
          }
          else if (key === 'InstabiliPegLieveTherapyIMM'){
            this.instabiliPegLieveIMM = values[i];
          }
          else if (key === 'InstabiliPegModerataTherapyIMM'){
            this.instabiliPegModerataIMM = values[i];
          }
          else if (key === 'InstabiliPegGraveTherapyIMM'){
            this.instabiliPegGraveIMM = values[i];
          }
          else if (key === 'InstabiliMiglRemissioneTherapyIMM'){
            this.instabiliMiglRemissioneIMM = values[i];
          }
          else if (key === 'InstabiliPegRemissioneTherapyIMM'){
            this.instabiliPegRemissioneIMM = values[i];
          }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGrave5ASAOS);
      this.attivitaGrave.push(this.instabiliMiglGrave5ASAOS);
      this.attivitaGrave.push(this.instabiliPegGrave5ASAOS);
      this.attivitaGrave.push(this.stabiliGraveTOPICA);
      this.attivitaGrave.push(this.instabiliMiglGraveTOPICA);
      this.attivitaGrave.push(this.instabiliPegGraveTOPICA);
      this.attivitaGrave.push(this.stabiliGraveGCSOS);
      this.attivitaGrave.push(this.instabiliMiglGraveGCSOS);
      this.attivitaGrave.push(this.instabiliPegGraveGCSOS);
      this.attivitaGrave.push(this.stabiliGraveBIO);
      this.attivitaGrave.push(this.instabiliMiglGraveBIO);
      this.attivitaGrave.push(this.instabiliPegGraveBIO);
      this.attivitaGrave.push(this.stabiliGraveIMM);
      this.attivitaGrave.push(this.instabiliMiglGraveIMM);
      this.attivitaGrave.push(this.instabiliPegGraveIMM);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieve5ASAOS);
      this.attivitaLieve.push(this.instabiliMiglLieve5ASAOS);
      this.attivitaLieve.push(this.instabiliPegLieve5ASAOS);
      this.attivitaLieve.push(this.stabiliLieveTOPICA);
      this.attivitaLieve.push(this.instabiliMiglLieveTOPICA);
      this.attivitaLieve.push(this.instabiliPegLieveTOPICA);
      this.attivitaLieve.push(this.stabiliLieveGCSOS);
      this.attivitaLieve.push(this.instabiliMiglLieveGCSOS);
      this.attivitaLieve.push(this.instabiliPegLieveGCSOS);
      this.attivitaLieve.push(this.stabiliLieveBIO);
      this.attivitaLieve.push(this.instabiliMiglLieveBIO);
      this.attivitaLieve.push(this.instabiliPegLieveBIO);
      this.attivitaLieve.push(this.stabiliLieveIMM);
      this.attivitaLieve.push(this.instabiliMiglLieveIMM);
      this.attivitaLieve.push(this.instabiliPegLieveIMM);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerata5ASAOS);
      this.attivitaModerata.push(this.instabiliMiglModerata5ASAOS);
      this.attivitaModerata.push(this.instabiliPegModerata5ASAOS);
      this.attivitaModerata.push(this.stabiliModerataTOPICA);
      this.attivitaModerata.push(this.instabiliMiglModerataTOPICA);
      this.attivitaModerata.push(this.instabiliPegModerataTOPICA);
      this.attivitaModerata.push(this.stabiliModerataGCSOS);
      this.attivitaModerata.push(this.instabiliMiglModerataGCSOS);
      this.attivitaModerata.push(this.instabiliPegModerataGCSOS);
      this.attivitaModerata.push(this.stabiliModerataBIO);
      this.attivitaModerata.push(this.instabiliMiglModerataBIO);
      this.attivitaModerata.push(this.instabiliPegModerataBIO);
      this.attivitaModerata.push(this.stabiliModerataIMM);
      this.attivitaModerata.push(this.instabiliMiglModerataIMM);
      this.attivitaModerata.push(this.instabiliPegModerataIMM);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione5ASAOS);
      this.remissione.push(this.instabiliMiglRemissione5ASAOS);
      this.remissione.push(this.instabiliPegRemissione5ASAOS);
      this.remissione.push(this.stabiliRemissioneTOPICA);
      this.remissione.push(this.instabiliMiglRemissioneTOPICA);
      this.remissione.push(this.instabiliPegRemissioneTOPICA);
      this.remissione.push(this.stabiliRemissioneGCSOS);
      this.remissione.push(this.instabiliMiglRemissioneGCSOS);
      this.remissione.push(this.instabiliPegRemissioneGCSOS);
      this.remissione.push(this.stabiliRemissioneBIO);
      this.remissione.push(this.instabiliMiglRemissioneBIO);
      this.remissione.push(this.instabiliPegRemissioneBIO);
      this.remissione.push(this.stabiliRemissioneIMM);
      this.remissione.push(this.instabiliMiglRemissioneIMM);
      this.remissione.push(this.instabiliPegRemissioneIMM);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableCrohnTherapy') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableCrohnTherapy = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableCrohnTherapy.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableCrohnTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableCrohnTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableCrohnTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableCrohnTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}